// web/src/utils/api.js
const API_BASE =
  process.env.REACT_APP_API_BASE   // optional override (e.g. "http://localhost:8000")
  || "";                           // default: use CRA proxy with relative paths

const join = (base, path) => {
  if (!base) return path;
  if (base.endsWith("/") && path.startsWith("/")) return base.slice(0, -1) + path;
  if (!base.endsWith("/") && !path.startsWith("/")) return base + "/" + path;
  return base + path;
};

export async function apiFetch(path, options = {}) {
  const url = join(API_BASE, path);
  const res = await fetch(url, {
    credentials: "include",
    ...options,
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
  });
  return res;
}

// Small JSON helper that throws on !ok
export async function request(path, options) {
  const r = await apiFetch(path, options);
  const ct = r.headers.get("content-type") || "";
  const body = ct.includes("application/json") ? await r.json().catch(()=>null) : await r.text();
  if (!r.ok) {
    const msg = (body && body.detail) || (typeof body === "string" ? body : "Erreur");
    const e = new Error(msg); e.status = r.status; e.body = body; throw e;
  }
  return body;
}

// Optional convenience helpers (used by VerifyEmail.jsx)
export const get  = (path)        => request(path, { method: "GET" });
export const post = (path, body)  => request(path, { method: "POST", body: JSON.stringify(body || {}) });

export const authApi = {
  me:        () => request("/api/auth/me"),
  signup:    (p) => request("/api/auth/signup",  { method: "POST", body: JSON.stringify(p) }),
  login:     (p) => request("/api/auth/login",   { method: "POST", body: JSON.stringify(p) }),
  logout:    ()  => request("/api/auth/logout",  { method: "POST" }),
  refresh:   ()  => request("/api/auth/refresh", { method: "POST" }),

  // email flows
  reqVerify: ()      => request("/api/auth/request-email-verification", { method: "POST" }),
  reqReset:  (email) => request("/api/auth/request-password-reset",      { method: "POST", body: JSON.stringify({ email }) }),
  resetPwd:  (token, new_password) =>
              request("/api/auth/reset-password", { method: "POST", body: JSON.stringify({ token, new_password }) }),

  // NEW
  updateProfile: (name) => request("/api/auth/update-profile", { method: "POST", body: JSON.stringify({ name }) }),
  changePassword:(current_password, new_password) =>
              request("/api/auth/change-password", { method: "POST", body: JSON.stringify({ current_password, new_password }) }),
};

export async function getMeQuota() {
  const r = await fetch("/api/me/quota", { credentials: "include" });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}